const handlePatientsStore = (state, patients) => {
  patients.forEach((newPatient) => {
    const index = state.patients.findIndex((p) => p.currentOrder.id === newPatient.id);
    const currSearchedPatient = state.searchedPatient;
    if (index > -1) {
      const currPatient = state.patients[index];
      const mergedPatient = {
        ...currPatient.currentOrder,
        ...newPatient,
        potentialSaving: { ...currPatient.potentialSaving, ...newPatient.potentialSaving }
      };
      state.patients[index].currentOrder = mergedPatient;
      state = { ...state, patients: [...state.patients] };
    } else if (currSearchedPatient !== undefined) {
      const mergedPatient = {
        ...currSearchedPatient,
        ...newPatient
      };
      state = { ...state, searchedPatient: mergedPatient };
    } else {
      state.patients.push(newPatient);
      state = { ...state, patients: [...state.patients] };
    }
  });

  return state;
};

const handleSearchedPatientsStore = (state, newPatients) => {
  if (!state.searchedPatients?.patients?.length) return state;

  const patientsCopy = [...(state.searchedPatients?.patients || [])];

  newPatients.forEach((newPatient) => {
    const index = patientsCopy.findIndex((p) => p.id === newPatient.id);

    if (index > -1) {
      const currPatient = patientsCopy[index];
      const mergedPatient = {
        ...currPatient,
        ...newPatient,
        potentialSaving: { ...currPatient.potentialSaving, ...newPatient.potentialSaving }
      };

      patientsCopy[index] = mergedPatient;
    }
  });

  return { ...state, searchedPatients: { ...state.searchedPatients, patients: patientsCopy } };
};

const EditPatientsReducer = (state, action) => {
  const { patients } = action;
  state = handlePatientsStore(state, patients);
  state = handleSearchedPatientsStore(state, patients);

  return state;
};

export { EditPatientsReducer };
